import React, { useState } from 'react';
import UploadStep from "./UploadStep";
import SaveItemsStep from "./SaveItemsStep";

/** Implements a generic import flow from a CSV file. Can be used to import a list of entities into the system. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function ImportWizard(props) {
  const {
    entityName,
    saveEntityName,
    importBtnText,
    csvTemplateUrl,
    testid,
    currentSaveData,
    parseAndValidateCsv,
    saveItem,
    onEvent,
    onStartSave
  } = props;
  const [step, setStep] = useState('uploadCsv');
  const [items, setItems] = useState([]);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testid
  }, step === 'uploadCsv' && /*#__PURE__*/React.createElement(UploadStep, {
    entityName: entityName,
    importBtnText: importBtnText,
    csvTemplateUrl: csvTemplateUrl,
    testid: testid,
    parseAndValidateCsv: parseAndValidateCsv,
    onEvent: onEvent,
    onStartImportItems: items => {
      onEvent && onEvent('startImportItems');
      setItems(items);
      setStep('saveItems');
    },
    onUploadCsv: (items, errors, badCsv) => {
      onEvent && onEvent('csvUploaded', {
        items,
        errors,
        badCsv
      });
    }
  }), step === 'saveItems' && /*#__PURE__*/React.createElement(SaveItemsStep, {
    items: items,
    saveEntityName: saveEntityName,
    currentSaveData: currentSaveData,
    testid: testid,
    saveItem: saveItem,
    onEvent: onEvent,
    onReset: () => setStep('uploadCsv'),
    onStartSave: onStartSave
  }));
}